export default "__VITE_ASSET__sALyRxTH__"